import React, { useContext, useEffect, useRef, useState } from "react";

import "../../styles/screens/screens.css";
import "../../styles/screens/general.scss";

import { Context } from "./../../provider/index";

import Header from "../general/Header";
import Footer from "../general/Footer";
import Border from "../general/Border";

const WelcomeScreen = () => {
  const timer = useRef();
  const [lang, setLang] = useState("fr");
  const { admin, dispatch } = useContext(Context);

  useEffect(() => {
    if (timer.current) {
      clearInterval(timer.current);
    }

    timer.current = setInterval(() => {
      setLang((l) => (l == "fr" ? "nl" : "fr"));
    }, 6000);

    dispatch({ type: "option", payload: 0 });
    dispatch({ type: "maxOptions", payload: 1 });
    dispatch({ type: "rulesToSwitch", payload: false });

    return () => {
      if (timer.current) {
        clearInterval(timer.current);
      }
    };
  }, []);

  return (
    <div className="uiContainer">
      <Header />
      <div
        className="uiField uiFieldBorders"
        style={{
          width: admin.size.w > 0 ? admin.size.w : null,
          height: admin.size.h > 0 ? admin.size.h : null,
        }}
      >
        <img src={`./images/gifs/INTRO_${lang}.gif`} alt="placeholder"></img>

        <Border />
      </div>
      <Footer>
        <img
          src="./images/gifs/go_welcomepage.gif" 
          className="welcomeGif"
          alt="welcome"
        />
        <small className="gifText">Press the button to start</small>
      </Footer>
    </div>
  );
};


export default WelcomeScreen;
